module.exports = __webpack_public_path__ + "static/media/Richard Chen.ad38134c.png";